var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-edicion',{attrs:{"title":"Crear unidad de negocio"}},[_c('page-header',{attrs:{"title":"Crear unidad de negocio","back-to":"/unidadesNegocio"}}),_c('formulario',{attrs:{"unidad-negocio":_vm.unidadNegocio,"paises-id":_vm.paisesId},on:{"submit":_vm.insertar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }